import api from "../index"
import { apiTags } from "../tags"

const reports = api.injectEndpoints({
  endpoints: (build) => ({
    getReportsData: build.query({
      query: ({ date }) => ({
        url: `/reports/admin-reports?date=${encodeURIComponent(
          JSON.stringify(date)
        )}`,
        method: "GET",
      }),
    }),

    createTds: build.mutation({
      query: (body) => ({
        url: `/reports/create-tds`,
        method: "POST",
        body,
      }),
    }),
    getTdsYears: build.query({
      query: (body) => ({
        url: `/reports/tds-years`,
        method: "POST",
        body,
      }),
    }),
    getTdsQuarter: build.query({
      query: (body) => ({
        url: `/reports/tds-months`,
        method: "POST",
        body,
      }),
    }),
    getTdsFiles: build.query({
      query: (body) => ({
        url: `/reports/tds-files`,
        method: "POST",
        body,
      }),
    }),
    deleteTdsFiles: build.mutation({
      query: (body) => ({
        url: `/reports/tds-delete-file`,
        method: "POST",
        body,
      }),
    }),
    getAdminOffers: build.query({
      query: () => ({
        url: `/reports/admin/offers`,
        method: "GET",
      }),
    }),
    getAdminOffersDashboard: build.query({
      query: (body) => ({
        url: `/reports/admin/fund-requests/dashboard`,
        method: "POST",
        body,
      }),
    }),
    getDashboardCompanies: build.query({
      query: (body) => ({
        url: `/reports/admin/dashboard/companies`,
        method: "POST",
        body,
      }),
    }),
    getDashboardPayableAmount: build.query({
      query: (body) => ({
        url: `/reports/admin/dashboard/payable/amount`,
        method: "POST",
        body,
      }),
    }),
    getDashboardWealthPartners: build.query({
      query: (body) => ({
        url: `/reports/admin/dashboard/wealthpartners`,
        method: "POST",
        body,
      }),
    }),
    getDashboardPayableAmountChart: build.query({
      query: (body) => ({
        url: `/reports/admin/dashboard/payable/amount/chart`,
        method: "POST",
        body,
      }),
    }),
    getDashboardMaturityTrackingAdmin: build.query({
      query: (body) => ({
        url: `/reports/admin/dashboard/maturity`,
        method: "POST",
        body,
      }),
    }),
  }),
})

export const {
  useLazyGetReportsDataQuery,
  useCreateTdsMutation,
  useLazyGetTdsYearsQuery,
  useLazyGetTdsQuarterQuery,
  useLazyGetTdsFilesQuery,
  useDeleteTdsFilesMutation,

  useLazyGetAdminOffersQuery,
  useLazyGetAdminOffersDashboardQuery,
  useLazyGetDashboardCompaniesQuery,
  useLazyGetDashboardPayableAmountQuery,
  useLazyGetDashboardWealthPartnersQuery,
  useLazyGetDashboardPayableAmountChartQuery,
  useLazyGetDashboardMaturityTrackingAdminQuery,
} = reports
